<template>
  <div
    v-appendTo="appendTo"
    :style="style"
    class="rotate-module-degrees"
    :class="{ 'rotate-module-degrees--rotating': isRotating }"
  >
    {{ `${rotationChange}&deg;` }}
  </div>
</template>

<script>
import { isNumber } from 'lodash-es';
import { tokens as nebulaTokens } from '@discoveryedu/nebula-core/dist/data/nebula_tokens.json';
import appendTo from '@/directives/appendTo';
import moduleRotation from '@/mixins/moduleRotation';

const nebulaSpace3x = parseInt(nebulaTokens.space['3x'], 10);

export default {
  directives: {
    appendTo,
  },
  mixins: [moduleRotation],
  props: {
    appendTo: {
      type: HTMLElement,
      required: true,
    },
    moduleElement: {
      type: HTMLElement,
      default: null,
    },
    moduleData: {
      type: Object,
      required: true,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      style: null,
      rotationChange: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.attachRotationHandlers();
    });
  },
  beforeUnmount() {
    this.removeRotationHandlers();
  },
  computed: {
    isRotating() {
      return isNumber(this.rotationChange);
    },
  },
  methods: {
    updateStyle() {
      const moduleRect = this.getModuleRectNotScaled();
      if (!moduleRect) return;
      // Display the current rotation degrees in the center of the module.
      this.style = {
        left: `${moduleRect.centerX - nebulaSpace3x / this.scale}px`,
        top: `${moduleRect.centerY - nebulaSpace3x / this.scale}px`,
        transform: `scale(${1 / this.scale})`,
      };
    },
    onRotationStart(args) {
      if (args.id !== this.moduleData.id) return;
      this.rotationChange = args.rotationDegrees;
      this.updateStyle();
    },
    onRotationChange(args) {
      if (args.id !== this.moduleData.id) return;
      this.rotationChange = args.rotationDegrees;
    },
    onRotationEnd(args) {
      if (args.id !== this.moduleData.id) return;
      this.rotationChange = null;
    },
  },
};
</script>

<style lang="stylus">
.rotate-module-degrees {
  align-items: center;
  background-color: $nebula-color-platform-neutral-500;
  border-radius: 50%;
  color: $nebula-color-white;
  display: none;
  font-weight: 500;
  height: $nebula-space-6x;
  justify-content: center;
  position: fixed;
  transform-origin: top left;
  width: $nebula-space-6x;

  &--rotating {
    display: flex;
  }
}
</style>
